export const eventsList = [
    { id: "1", name: 'Classical Music' },
    { id: "2", name: 'Light Music' },
    { id: "3", name: 'Western Music' },
    { id: "4", name: 'Indian Music' },
    { id: "5", name: 'Bharatanatyam' },
    { id: "6", name: 'Mohiniyattam' },
    { id: "7", name: 'Folk Dance' },
    { id: "8", name: 'Cinematic Dance' },
    { id: "9", name: 'Creative - Kanj Got Talent' },
    { id: "10", name: 'Instrumental Music - String' },
    { id: "11", name: 'Instrumental Music - Keyboard' },
    { id: "12", name: 'Public Speaking-English' },
    { id: "13", name: 'Story Telling-English/Malayalam' },
    { id: "14", name: 'Fancy Dress' },
    { id: "15", name: 'Story Writing English' },
    { id: "16", name: 'Painting Water Color' },
    { id: "17", name: 'Pencil Sketching' },
    { id: "18", name: 'Public Speaking-Malayalam' },
    { id: "19", name: 'Cinematic Dance-Group' },
];

export const gradesList = [
    '1st-3rd Grade',
    '4th-6th Grade',
    '7th-9th Grade',
    '10th-12th Grade'
];